<template>
  <MUIDialog
    :dismissItem="dismissItem"
    :displayType="displayType"
    :scrollable="true"
    :title="title">
    <section>
      <h1>Saving Recipes</h1>
      <h2>Desktop Browser</h2>
      <p>Cookmark uses a bookmarklet for saving recipes to your collection. Bookmarklets are little javascript links that live in the bookmarks toolbar of your browser.<p>
      <MUIChip url="bookmarkUrl">Save to Cookmark</MUIChip>
      <p>If you use Firefox, Safari, Chrome or Opera, you can drag the link above to your bookmarks toolbar. You can rename the bookmarklet to whatever you like by right-clicking and choosing 'edit name'.</p>
      <p>If you're using Internet Explorer, dragging won't work. Right-click on the bookmarklet instead, and select 'add to Favorites' at the prompt.</p>
      <h2>iOS</h2>
      <p>iOS makes it somewhat difficult to add bookmarklets. Follow these instructions to get a 'Save to Cookmark' bookmarklet working on your device.</p>
      <ol>
        <li>Add this page as a bookmark (click on the box with the arrow in it next to the Safari address bar)</li>
        <li>Click the open book icon, select 'edit', and rename the bookmark to something like 'Save to Cookmark'</li>
        <li>Copy the following text<br />
          <textarea v-bind:style="{ width: '100%', height: '220px' }" v-model="bookmarkUrl"></textarea>
        </li>
        <li>Edit the bookmark you just made and paste the text you copied into the URL field</li>
        <li>Save your changes and test the bookmarklet by saving a recipe URL to Cookmark</li>
      </ol>
    </section>
  </MUIDialog>
</template>

<script>
import {
  MUIChip,
  MUIDialog
} from '../components'

import { APP } from '../config'

export default {
  components: {
    MUIChip,
    MUIDialog
  },
  computed: {
    bookmarkUrl () {
      // eslint-disable-next-line no-script-url
      return `javascript:q=location.href;p=document.title;void(t=open('http://cookmark.herokuapp.com/add?t=direct&url='+encodeURIComponent(q)+'&title='+encodeURIComponent(p),'cookmark.io','toolbar=no,width=100,height=100'));t.blur();`
    }
  },
  data () {
    return {
      dismissItem: {
        name: 'Done'
      },
      displayType: APP,
      title: 'Help'
    }
  }
}
</script>

<style lang="sass" scope>
.mui-layout__article--guide
  margin: 24px
  .has-toolbar &
    top: 61px
  h2
    margin-top: 24px
  p
    margin-top: 12px
  ul, ol
    margin-left: 16px
    li
      margin-top: 8px
      margin-bottom: 0
  textarea
    font-family: monospace
    font-size: 14px
    margin-top: 12px
</style>



// WEBPACK FOOTER //
// src/views/HelpDialog.vue